var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSubmit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.504 5.366 11.31 7.2H2.788A.793.793 0 0 0 2 8c0 .442.352.8.788.8h8.522l-1.806 1.834a.804.804 0 0 0 0 1.131.78.78 0 0 0 1.114 0l3.15-3.199a.812.812 0 0 0 0-1.133l-3.15-3.198a.78.78 0 0 0-1.114 0 .81.81 0 0 0 0 1.13",
  clipRule: "evenodd"
})));
export default SvgGemSubmit;